/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */
import React from 'react';

import { cssMap as unboundedCssMap } from '@compiled/react';
import { useIntl } from 'react-intl';

import { jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Text } from '@atlaskit/primitives/compiled';
import { token, useThemeObserver } from '@atlaskit/tokens';

import gesturalLineDark from './assets/gestural-line-dark.svg';
import gesturalLine from './assets/gestural-line.svg';
import { messages } from './messages';

const gesturalLineStyles = unboundedCssMap({
	root: {
		top: '75px',
		left: '58px',
		zIndex: 1,
		height: '180px',
		display: 'flex',
		boxSizing: 'border-box',
		gap: token('space.050'),
		columnGap: '4px',
		alignItems: 'center',
	},
});

const floatingTextboxStyles = unboundedCssMap({
	root: {
		top: '52px',
		left: '75px',
		width: '230px',
		zIndex: 1,
		position: 'relative',
		display: 'flex',
		boxSizing: 'border-box',
		alignItems: 'normal',
		flexDirection: 'column',
	},
});

/**
 * This the recommendation text and graphic that points out to the user that they should go for Standard.
 */
export const FloatingRecommendation = (): JSX.Element => {
	const { formatMessage } = useIntl();
	const { colorMode } = useThemeObserver();

	const isDarkMode = colorMode === 'dark';
	const gesturalLineImage = isDarkMode ? gesturalLineDark : gesturalLine;

	return (
		<>
			<div css={floatingTextboxStyles.root}>
				<Heading size="medium">{formatMessage(messages.recommended)}</Heading>
				<Text size="medium">{formatMessage(messages.basedOnYourUsage)}</Text>
			</div>
			<div css={gesturalLineStyles.root}>
				<img src={gesturalLineImage} alt={formatMessage(messages.gesturalLineAltText)} />
			</div>
		</>
	);
};
